export const PBL_DISPLAY_DASH = '-';

export const formatPblDisplayValue = (value?: string | number | null) => {
  const text = value === null || value === undefined ? '' : String(value).trim();
  return text || PBL_DISPLAY_DASH;
};

export const formatPblEnglishChineseName = (
  nameEn?: string | null,
  nameZh?: string | null,
  fallback?: string | null
) => {
  const englishName = nameEn?.trim() || '';
  const chineseName = nameZh?.trim() || '';

  if (englishName || chineseName) {
    return `${englishName || PBL_DISPLAY_DASH} / ${chineseName || PBL_DISPLAY_DASH}`;
  }

  return formatPblDisplayValue(fallback);
};
